<template>
  <div class="not-found-section">
      <div class="centered">
        <h1>{{ title }}</h1>
        <p>{{ msg }}</p>
        <p>Or, <router-link to="/" class="not-found-redirect">check this out.</router-link></p>
      </div>
  </div>
</template>

<script>
export default {
  name: "notFound",
  data() {
    return {
      title: "YOU'VE BEEN 404'D",
      msg: "The page you are looking for does not exist. Try again."
    };
  }
};
</script>